module.exports = __webpack_public_path__ + "static/media/pig-teal.2f909c43.webp";